import type { UIViewInjectedProps } from '@uirouter/react';
import { observer } from 'mobx-react-lite';

import { api } from '@/api';
import { PERMISSION_OBJ_WAYBILL } from '@/constants/permissions';
import { getAllowedFormFields } from '@/components/generic-form/utils';
import { DrawerForm } from '@/components/drawer-form';
import { addressStore, waybillStore } from '@/stores';
import { getTranslatedString } from '@/utils';
import { useMassUpdateCashedStores } from '@/utils/store';
import { showError } from '@/utils/common';
import { getFormFields } from './setup';

export const FactoryForm = observer(({ transition }: UIViewInjectedProps) => {
  const { waybillId } = transition.router.globals.params;
  const { selectedWaybills = [] } = transition.targetState().params();
  const { loading } = useMassUpdateCashedStores([addressStore]);

  const resourceController = {
    create: async (values: { factoryId: number }) => {
      const items = selectedWaybills.map((id) => ({ id, factoryId: values.factoryId }));
      try {
        const result = await api.waybills.bulkUpdate({ items }).source;
        if (result?.data?.items) {
          result.data.items.forEach((item) => {
            waybillStore.updateItem(item);
          });
        }
      } catch (err) {
        showError(err);
      }
    },
  };

  const onClose = () => {
    transition.router.stateService.go('base-layout.waybills');
  };

  const initValues = {};
  const title = getTranslatedString('waybill.factory.title', { 0: selectedWaybills.join(', ') || waybillId });
  const formFields = getFormFields();
  const allowedFields = getAllowedFormFields(formFields, true, PERMISSION_OBJ_WAYBILL);

  return (
    <DrawerForm
      title={title}
      initValues={initValues}
      formFields={allowedFields}
      onClose={onClose}
      resourceController={resourceController}
      loaderCondition={loading}
    />
  );
});
